import { Pipe, PipeTransform } from '@angular/core';
import { TaskStateColor } from './task-state-pipe-color';

@Pipe({
    name: 'TaskState',
    standalone: false
})
export class TaskStatePipe implements PipeTransform {
  transform(value: string): any {
    // Logic to determine styles based on the input value
    return {
      'color': TaskStateColor.getTaskStatusColor(value),
    };
  }
}
